import React from 'react';
import { Box, Stack } from '@mui/material';

// import ThinkingLoader from '../../../common-components/ThinkingLoader';
import ChatTimeLineItem from './ChatTimeLineItem';
import useChatSessionHandler from '../hooks/useChatSessionHandler';
import ChatSessionLoadingSkeleton from './ChatSessionLoadingSkeleton';
import { SENDER_TYPES } from '../slice/constants';
import ThinkingLoader from '../../../common-components/ThinkingLoader';

interface ChatSessionProps {
  streamingData: string;
  isStreaming: boolean;
}

export function ChatSession({ streamingData, isStreaming }: ChatSessionProps) {
  const { messages, isLoading } = useChatSessionHandler();

  return (
    <>
      {isLoading && <ChatSessionLoadingSkeleton />}
      {!isLoading && (
        <Box
          sx={{
            flex: 1,
            overscrollBehaviorY: 'contain',
            width: '100%',
            p: '2rem 0rem',
          }}
        >
          <Stack spacing={2}>
            {messages.map((message) => (
              <>
                <ChatTimeLineItem key={message._id} sender={message.sender} assistantResponse={message.message} />
              </>
            ))}
            {isStreaming && !streamingData && <ChatTimeLineItem sender={SENDER_TYPES.ASSISTANT} assistantResponse={<ThinkingLoader />} />}
            {streamingData && <ChatTimeLineItem sender={SENDER_TYPES.ASSISTANT} assistantResponse={streamingData} />}

            {/* <div ref={messagesEndRef} /> */}
          </Stack>
        </Box>
      )}
    </>
  );
}
